// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { SHUTDOWN_TYPE } from '@/constant/rental';

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

export default {

    extends: baseRentalService,

    data() {

        return {
            shutdownType: SHUTDOWN_TYPE,

            dataNote: [
                {
                    label: this.$t('shutdownMachineModal.notesTitle'),
                    children: [
                        {
                            label: this.$t('shutdownMachineModal.note1'),
                        },
                        {
                            label: this.$t('shutdownMachineModal.note2'),
                        },
                        {
                            label: this.$t('shutdownMachineModal.note3'),
                        },
                    ]
                },
            ],
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    methods: {

        //#region  Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.SHUTDOWN_MACHINE);
        },
        //#endregion

        //#region Shutdown machine
        shutdown(type) {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    machineId: this.targetImage.id,
                    shutdownType: type,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                api.baseRequest(SETTINGS_RENTAL_API.SHUTDOWN_MACHINE, data)
                    .then((res) => {
                        EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                        EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                        this.closeThisPopup();
                        this.notificationSuccess(this.$t('shutdownMachineModal.successTitle'), this.$t('shutdownMachineModal.successMessage', { id: this.targetImage.id, name: this.targetImage.name }));
                        if (res.data) {
                            setTimeout(() => {
                                EventBus.$emit("processingEventApp", {
                                    event: "processOpenPopup",
                                    data: {
                                        type: POPUP_ID.RATE_IMAGE,
                                        data: res.data,
                                    },
                                });
                            }, 500);
                            this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                        }
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, this.$t('shutdownMachineModal.failedMessage'))
                    });
            }, this.smoothTimeOut);
        },
        //#endregion
    },
}